import React, { useEffect, useRef} from 'react';
import Reveal from "reveal.js";
import cx from 'classnames';
import "reveal.js/dist/reveal.css";

// https://stackoverflow.com/questions/54322703/import-and-read-the-contents-of-a-css-file-as-text-react-webpack
// eslint-disable-next-line import/no-webpack-loader-syntax

var theme_css = {};

import beige_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/beige.css';
theme_css["beige"] = beige_css;

import moon_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/moon.css';
theme_css["moon"] = moon_css;

import night_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/night.css';
theme_css["night"] = night_css;

import league_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/league.css';
theme_css["league"] = league_css;

import white_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/white.css';
theme_css["white"] = white_css;

import dracula_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/dracula.css';
theme_css["dracula"] = dracula_css;

import solarized_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/solarized.css';
theme_css["solarized"] = solarized_css;

import black_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/black.css';
theme_css["black"] = black_css;

import sky_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/sky.css';
theme_css["sky"] = sky_css;

import blood_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/blood.css';
theme_css["blood"] = blood_css;

import whiteContrast_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/white-contrast.css';
theme_css["white-contrast"] = whiteContrast_css;

import blackContrast_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/black-contrast.css';
theme_css["black-contrast"] = blackContrast_css;

import simple_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/simple.css';
theme_css["simple"] = simple_css;

import serif_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/serif.css';
theme_css["serif"] = serif_css;

import white_contrast_compact_verbatim_headers_css from '!!css-loader?{"sourceMap":false}!reveal.js/dist/theme/white_contrast_compact_verbatim_headers.css';
theme_css["white_contrast_compact_verbatim_headers"] = white_contrast_compact_verbatim_headers_css;


// https://stackoverflow.com/questions/57436372/dynamically-load-css-based-on-condition-in-reactjs-application
// const ThemeNight = lazy(() => import("reveal.js/dist/theme/night.css"));

import "./view.css";

const RevealView = (props) => {
  const deckDivRef = useRef<HTMLDivElement>(null); // reference to deck container div
  const deckRef = useRef<Reveal.Api | null>(null); // reference to deck reveal instance
  const { data } = props;

  const handleMDChange = (event) => {
    try {
      data.markdown = event.target.value;
    } catch (e) {
      console.error(e);
    }
  }

  let mdfile = '';
  if ( data.mdFileURL && data.mdFileURL.length >= 1 ) {
    mdfile = data.mdFileURL[0]['getURL'];
    if (mdfile && typeof(location) != 'undefined')  {
      mdfile = '/++api++/'
	+ mdfile.replace(location.origin, '')
	+ '/@@download/file';
    } else {
      mdfile = data.mdFileURL[0]['@id'];
    }
    if ( !mdfile ) mdfile = '';
  }

  useEffect(() => {
    if (deckRef.current) return; // Prevents double initin strict mode
    const clientSideInitialization = async () => {
      // load modules in browser
      const Reveal = (await import(
	"reveal.js")).default;
      const RevealMarkdown = (await import(
	"reveal.js/plugin/markdown/markdown.esm.js")).default;
      deckRef.current = new Reveal(deckDivRef.current!, {
	embedded: true,
	hash: true,
	transition: data.transition || 'slide',
	keyboardCondition: 'focused',
	keyboard: data.keyboard,
	loop: data.loop ,
	controls: data.controls ,
	autoSlide: data.autoslide || 0 ,
	scrollActivationWidth: data.scrollactivationwidth || 0,
	plugins: [RevealMarkdown]
      });

      deckRef.current.initialize().then(() => {
	// console.log("clientSideInit complete");
      });
    }
    clientSideInitialization();

    return () => {
      try {
        if (deckRef.current) {
          deckRef.current.destroy();
          deckRef.current = null;
        }
      } catch (e) {
        console.warn("Reveal.js destroy call failed.");
      }
    };
  }, []);

  return (
    // Your presentation is sized based on the width and height of
    // our parent element. Make sure the parent is not 0-height.
    <div
      className={
	cx('block reveal-wrap align',
	   {
	     center: !Boolean(data.align),
	     'full-width': data.align === 'full',
	  },
	   data.align
	  )
      }
      style={{ height: data.height || '40vh' }}
    >
      <style>
	{ theme_css[data.theme]
	  ? theme_css[data.theme].toString()
	  :  moon_css.toString() }
      </style>
      <div
	className="reveal reveal-viewport"
	ref={deckDivRef}>

	<div className="slides">
	  <section
	    data-markdown={mdfile}
	    data-separator="^\r?\n---\r?\n$"
	    data-separator-vertical="^\r?\n--\r?\n$"
	  >
	    <textarea
	      id="slidemd"
	      data-template=""
	      defaultValue={data.markdown}
	    />
	  </section>
	</div>
      </div>
    </div>
  );
};

export default RevealView;
